const valid = {
  REQUIRE_TITLE: '제목을 입력해 주세요',
  REQUIRE_FILE: '파일을 선택해 주세요',
  REQUIRE_URL: '동영상 URL을 입력해 주세요',
  REQUIRE_ID: '아이디를 입력해 주세요.',
  REQUIRE_PASSWORD: '비밀번호를 입력해 주세요.',
  REQUIRE_NAME: '이름을 입력해 주세요.',
  REQUIRE_GENDER: '성별을 선택해 주세요.',
  REQUIRE_PHONE: '휴대폰 번호를 입력해 주세요.',
  REQUIRE_EMAIL: '이메일을 입력해 주세요.',
  REQUIRE_EMAIL_CONFIRM: '이메일 인증을 완료해 주세요.',
  REQUIRE_NICKNAME: '닉네임을 입력해 주세요.',
  REQUIRE_NICKNAME_CONFIRM: '닉네임 중복확인을 완료해 주세요.',
  REQUIRE_BIRTH: '생년월일을 입력해 주세요',
  REQUIRE_DATE: '날짜를 선택해 주세요.',
  REQUIRE_CONTENT: '내용을 입력해 주세요.',

  INVALID_URL: '올바른 URL을 입력해 주세요',
  INVALID_ID: '올바른 형식의 아이디를 입력해 주세요.',
  INVALID_PASSWORD: '올바른 형식의 비밀번호를 입력해 주세요.',
  INVALID_PASSWORD_CONFIRM: '비밀번호와 일치하지 않습니다.',
  INVALID_NAME: '올바른 형식의 이름을 입력해 주세요.',
  INVALID_PHONE: '올바른 휴대폰 번호를 입력해 주세요.',
  INVALID_EMAIL: '올바른 형식의 이메일을 입력해 주세요.',
  INVALID_START_DATE: '시작날짜와 종료날짜를 확인해 주세요.',

  VALID_EMAIL_CONFIRM: '이메일 인증이 완료되었습니다.',
  VALID_NICKNAME_CONFIRM: '닉네임 중복확인이 완료되었습니다.',
}
const info = {
  SUCCESS_SIGNUP: '회원가입이 성공하였습니다.',
  SUCCESS_ADD_VIDEO: '동영상이 성공적으로 추가되었습니다.',
  SUCCESS_ADD_FILE: '파일이 성공적으로 추가되었습니다.',
  SUCCESS_SEND_EMAIL_OTP: '해당 이메일로 인증코드를 전송하였습니다.',
  SUCCESS_FETCH_USERINFO: '유저정보가 성공적으로 수정되었습니다.',
  SUCCESS_DELETE_USER: '해당 유저가 성공적으로 삭제되었습니다.',
  SUCCESS_CHANGE_AUTHORITIES: '해당 유저의 권한이 성공적으로 변경되었습니다.',
  SUCCESS_CREATE_NOTICE: '공지사항이 성공적으로 등록되었습니다.',
  SUCCESS_MODIFY_NOTICE: '공지사항이 성공적으로 수정되었습니다.',
  SUCCESS_DELETE_NOTICE: '공지사항이 성공적으로 삭제되었습니다.',
}
const error = {
  FAIL_ADD_VIDEO: '동영상을 업로드가 실패하였습니다.',
  FAIL_ADD_FILE: '파일 업로드가 실패하였습니다.',
  FAIL_ADD_FILE_BECAUSE_SIZE: '파일의 용량제한을 초과하였습니다.',
}
const question = {
  DELETE_VIDEO: '정말로 동영상을 삭제하시겠습니까?',
  DELETE_FILE: '정말로 파일을 삭제하시겠습니까?',
  DELETE_USER: '정말로 해당 유저를 삭제하시겠습니까?',
  DELETE_NOTICE: '정말로 공지사항을 삭제하시겠습니까?',
}

export const Message = { info, valid, error, question }
